import { render, staticRenderFns } from "./donation.vue?vue&type=template&id=40482b67&"
import script from "./donation.vue?vue&type=script&lang=js&"
export * from "./donation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40482b67')) {
      api.createRecord('40482b67', component.options)
    } else {
      api.reload('40482b67', component.options)
    }
    module.hot.accept("./donation.vue?vue&type=template&id=40482b67&", function () {
      api.rerender('40482b67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sections/donation/donation.vue"
export default component.exports